/**
 * @description
 * Employee Loan Company headers
 * 
 * @type       {array}
 */
export default [
    {
        text: '#',
        value: 'id',
        sortable: true,
        width: '5%',
    },
    {
        text: 'empleado',
        value: 'hr_employee_full_name',
        width: '25%',
    },
    {
        text: 'periodo',
        value: 'period_str',
    },
    {
        text: 'inicio',
        value: 'start_date',
        align: 'right',
        format: 'date-custom',
        options: 'YYYY-MM',
    },
    {
        text: 'termino',
        value: 'end_date',
        align: 'right',
        format: 'date-custom',
        options: 'YYYY-MM',
    },
    {
        text: 'monto',
        value: 'quote_amount',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'cuotas',
        value: 'quote_total',
        align: 'right',
    },
    {
        text: 'cuotas pagadas',
        value: 'quote_paid',
        align: 'right',
    },
    {
        text: 'creacion',
        value: 'created_at',
        align: 'right',
        format: 'datetime',
    },
]
